import { useState } from "react";
import { Head } from "@inertiajs/react";

import Layout from "/Layout";
import ProjectsList from "/components/Projects/List";

export default function ProjectIndex({
  locale,
  public_page,
}) {
  return (
    <>
      <Head>
        {public_page.og_title && (<meta head-key="og:title" key="og:title" property="og:title" content={public_page.og_title} />)}
        {public_page.og_description && (<meta head-key="og:description" key="og:description" property="og:description" content={public_page.og_description} />)}
        {public_page.og_image.type && (<meta key="og:image:type" property="og:image:type" content={public_page.og_image.type} />)}
        {public_page.og_image.url && (<meta key="og:image" property="og:image" content={public_page.og_image.url} />)}
        {public_page.og_image.url && (<meta key="og:image:width" property="og:image:width" content="1200" />)}
        {public_page.og_image.url && (<meta key="og:image:height" property="og:image:height" content="630" />)}

        {public_page.og_title && (<meta head-key="twitter:title" key="twitter:title" name="twitter:title" content={public_page.og_title} />)}
        {public_page.og_description && (<meta head-key="twitter:description" key="twitter:description" name="twitter:description" content={public_page.og_description} />)}
        {public_page.og_image.url && (<meta head-key="twitter:card" key="twitter:card" name="twitter:card" content="summary_large_image" />)}
        {public_page.og_image.type && (<meta key="twitter:image:type" name="twitter:image:type" content={public_page.og_image.type} />)}
        {public_page.og_image.url && (<meta key="twitter:image" name="twitter:image" content={public_page.og_image.url} />)}
        {public_page.og_image.url && (<meta key="twitter:image:width" name="twitter:image:width" content="1200" />)}
        {public_page.og_image.url && (<meta key="twitter:image:height" name="twitter:image:height" content="630" />)}
      </Head>

      <Layout>
        <ProjectsList sourceURL={`/${locale}/projects`} />
      </Layout>
    </>
  );
}
